export const getFirebaseErrorMessage = (code) => {
  let message = "An unknown error occurred. Please try again.";
  switch (code) {
    case "auth/user-not-found":
      message = "No user found with this email address.";
      break;
    case "auth/wrong-password":
      message = "Incorrect password. Please try again.";
      break;
    case "auth/invalid-email":
      message = "Please enter a valid email address.";
      break;
    case "auth/email-already-in-use":
      message = "This email is already registered. Please sign in or use a different email.";
      break;
    // Add more cases for other relevant error codes
    default:
      message = "Authentication failed. Please check your credentials.";
      break;
  }
  return message;
};